import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleDownloadCapabilities = () => {
    const htmlContent = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Jerilyn Emerson – Capabilities Statement</title>
  <link href="https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400&family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    @page { size: letter; margin: 0; }
    body {
      font-family: 'Inter', sans-serif;
      color: #1a2b4a;
      background: #fff;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .page {
      width: 8.5in;
      min-height: 11in;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
    }
    .header {
      background: #1a2b4a;
      padding: 0.55in 0.6in 0.45in;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 0.3in;
    }
    .header-left h1 {
      font-family: 'Crimson Text', serif;
      font-size: 38pt;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: -0.5px;
      line-height: 1.1;
      margin-bottom: 6px;
    }
    .header-left .tagline {
      font-size: 10pt;
      font-weight: 400;
      color: #2d9b9b;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
    .header-right { text-align: right; flex-shrink: 0; }
    .header-right p { font-size: 8.5pt; color: rgba(255,255,255,0.75); line-height: 1.8; }
    .header-right a { color: #2d9b9b; text-decoration: none; }
    .accent-bar { height: 5px; background: linear-gradient(90deg, #2d9b9b 0%, #1a2b4a 100%); }
    .body { display: grid; grid-template-columns: 2.4in 1fr; flex: 1; }
    .sidebar { background: #f4f7f9; padding: 0.4in 0.3in; border-right: 1px solid #e2e8f0; }
    .sidebar-section { margin-bottom: 0.3in; }
    .sidebar-section:last-child { margin-bottom: 0; }
    .sidebar-label {
      font-size: 7pt; font-weight: 600; letter-spacing: 2px;
      text-transform: uppercase; color: #2d9b9b;
      margin-bottom: 10px; padding-bottom: 6px;
      border-bottom: 1.5px solid #2d9b9b;
    }
    .sidebar-item {
      font-size: 8.5pt; color: #1a2b4a; line-height: 1.6;
      padding: 3px 0; display: flex; align-items: flex-start; gap: 6px;
    }
    .sidebar-item::before { content: '\\25B8'; color: #2d9b9b; font-size: 8pt; flex-shrink: 0; margin-top: 1px; }
    .credential-badge {
      display: inline-block; background: #fff; border: 1px solid #2d9b9b;
      color: #1a2b4a; font-size: 7.5pt; font-weight: 500;
      padding: 3px 8px; border-radius: 20px; margin: 3px 2px 0 0; line-height: 1.5;
    }
    .main { padding: 0.4in 0.45in; }
    .section { margin-bottom: 0.28in; }
    .section-title {
      font-size: 7pt; font-weight: 600; letter-spacing: 2px;
      text-transform: uppercase; color: #2d9b9b;
      margin-bottom: 10px; padding-bottom: 6px;
      border-bottom: 1.5px solid #e2e8f0;
    }
    .section p { font-size: 9pt; line-height: 1.75; color: #334155; }
    .services-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
    .service-card {
      background: #f8fafc; border-left: 3px solid #2d9b9b;
      padding: 10px 12px; border-radius: 0 6px 6px 0;
    }
    .service-card h4 { font-size: 8.5pt; font-weight: 600; color: #1a2b4a; margin-bottom: 4px; }
    .service-card p { font-size: 7.5pt; color: #64748b; line-height: 1.55; }
    .footer {
      background: #1a2b4a; padding: 14px 0.6in;
      display: flex; align-items: center; justify-content: space-between;
    }
    .footer p { font-size: 7.5pt; color: rgba(255,255,255,0.55); }
    .footer .footer-brand { font-family: 'Crimson Text', serif; font-size: 11pt; font-weight: 600; color: #fff; }
    @media print { body { margin: 0; } .page { width: 100%; } }
  </style>
</head>
<body>
<div class="page">
  <div class="header">
    <div class="header-left">
      <h1>Jerilyn Emerson</h1>
      <p class="tagline">Organizational Strategy &nbsp;|&nbsp; Leadership Advisory &nbsp;|&nbsp; Executive Coaching</p>
    </div>
    <div class="header-right">
      <p>Washington, DC Area</p>
      <p><a href="mailto:jerilyn@jerilynemerson.com">jerilyn@jerilynemerson.com</a></p>
      <p><a href="https://jerilynemerson.com">jerilynemerson.com</a></p>
      <p><a href="https://linkedin.com/in/jerilynemerson">linkedin.com/in/jerilynemerson</a></p>
    </div>
  </div>
  <div class="accent-bar"></div>
  <div class="body">
    <div class="sidebar">
      <div class="sidebar-section">
        <div class="sidebar-label">Areas of Expertise</div>
        <div class="sidebar-item">Organizational Strategy &amp; Strategic Planning</div>
        <div class="sidebar-item">Leadership Development &amp; Executive Coaching</div>
        <div class="sidebar-item">Leadership Team Facilitation</div>
        <div class="sidebar-item">Organizational Design &amp; Transformation</div>
        <div class="sidebar-item">People Strategy &amp; Talent Systems</div>
        <div class="sidebar-item">Compensation Strategy &amp; Pay Equity</div>
        <div class="sidebar-item">Change Leadership</div>
      </div>
      <div class="sidebar-section">
        <div class="sidebar-label">Credentials</div>
        <span class="credential-badge">Certified Executive Coach</span>
        <span class="credential-badge">Org Development Practitioner</span>
        <span class="credential-badge">DiSC Certified</span>
        <span class="credential-badge">Birkman Certified</span>
        <span class="credential-badge">CliftonStrengths Certified</span>
      </div>
      <div class="sidebar-section">
        <div class="sidebar-label">Client Focus</div>
        <div class="sidebar-item">Nonprofit Organizations</div>
        <div class="sidebar-item">Foundations</div>
        <div class="sidebar-item">Social Impact Organizations</div>
        <div class="sidebar-item">Advocacy Groups</div>
        <div class="sidebar-item">Executive Leadership Teams</div>
      </div>
      <div class="sidebar-section">
        <div class="sidebar-label">Experience</div>
        <div class="sidebar-item">20+ years of leadership experience</div>
        <div class="sidebar-item">Chief Operating Officer – Greenpeace USA</div>
        <div class="sidebar-item">Chief People &amp; Culture Officer – Greenpeace USA</div>
        <div class="sidebar-item">Chief of Staff – Greenpeace USA</div>
      </div>
    </div>
    <div class="main">
      <div class="section">
        <div class="section-title">Professional Summary</div>
        <p>Jerilyn Emerson is an organizational strategist and executive coach who partners with nonprofit and social impact leaders navigating complex organizational change. With more than 20 years of leadership experience, Jerilyn helps mission-driven organizations strengthen leadership teams, align strategy with operations, and build people systems that support lasting impact.</p>
        <br/>
        <p>Jerilyn brings a unique combination of executive leadership experience and strategic advisory expertise. She works with leaders as a thought partner and trusted advisor during moments of growth, transition, and transformation — advising nonprofit executives, social impact leaders, and senior leadership teams seeking to strengthen leadership capacity and align strategy with the people and systems needed to deliver meaningful impact.</p>
      </div>
      <div class="section">
        <div class="section-title">Core Services</div>
        <div class="services-grid">
          <div class="service-card">
            <h4>Organizational Strategy</h4>
            <p>Strategic planning and organizational development support — including theory of change, organizational design, and implementation planning.</p>
          </div>
          <div class="service-card">
            <h4>Leadership Team Facilitation</h4>
            <p>Facilitated sessions that strengthen collaboration, decision-making, and alignment across executive teams navigating complex change.</p>
          </div>
          <div class="service-card">
            <h4>Executive Coaching</h4>
            <p>One-on-one coaching for nonprofit executives and senior leaders focused on leadership effectiveness, strategic thinking, and executive presence.</p>
          </div>
          <div class="service-card">
            <h4>People Strategy &amp; Org Design</h4>
            <p>Advising on leadership development, talent management, organizational structure, and culture to support strategic goals.</p>
          </div>
          <div class="service-card">
            <h4>Compensation Strategy &amp; Pay Equity</h4>
            <p>Developing equitable, transparent compensation structures that strengthen retention and align with organizational values.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <span class="footer-brand">Jerilyn Emerson</span>
    <p>Capabilities Statement &nbsp;·&nbsp; Confidential</p>
    <p>© 2025 Jerilyn Emerson Consulting</p>
  </div>
</div>
<script>window.onload = function() { window.print(); };<\/script>
</body>
</html>`;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onunload = () => URL.revokeObjectURL(url);
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.currentTarget;
      const formDataToSend = new FormData(formElement);

      const response = await fetch('https://readdy.ai/api/form/d6n22l14a3uojp5fgvgg', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', organization: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16">
          {/* Left Side */}
          <div className="lg:col-span-2">
            <div className="bg-[#2d9b9b] rounded-3xl p-12 relative overflow-hidden h-full flex flex-col justify-center">
              {/* Decorative Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-64 h-64 border-4 border-white rounded-full -mr-32 -mt-32"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 border-4 border-white rounded-full -ml-24 -mb-24"></div>
              </div>

              <div className="relative z-10">
                <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Crimson Text, serif' }}>
                  Let's Start the Conversation
                </h2>

                <p className="text-lg text-white/90 leading-relaxed mb-8">
                  Whether you're facing a specific challenge or exploring how strategic support could benefit your organization, I'd love to hear from you.
                </p>

                <button 
                  onClick={handleDownloadCapabilities}
                  className="inline-flex items-center gap-2 border-2 border-white text-white px-6 py-3 rounded-full hover:bg-white hover:text-[#2d9b9b] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line"></i>
                  Download Capabilities Statement
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="lg:col-span-3">
            <div className="mb-8">
              <span className="text-[#1a2b4a] text-sm font-semibold tracking-wide uppercase">Get in Touch</span>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contact-form">
              <div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  placeholder="Your Name"
                  required
                  className="w-full px-6 py-4 border border-gray-300 rounded-xl text-[#1a2b4a] text-sm focus:outline-none focus:border-[#2d9b9b] focus:ring-2 focus:ring-[#2d9b9b]/20 transition-all duration-300"
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="Email Address"
                  required
                  className="w-full px-6 py-4 border border-gray-300 rounded-xl text-[#1a2b4a] text-sm focus:outline-none focus:border-[#2d9b9b] focus:ring-2 focus:ring-[#2d9b9b]/20 transition-all duration-300"
                />
              </div>

              <div>
                <input
                  type="text"
                  name="organization"
                  value={formData.organization}
                  onChange={(e) => setFormData({ ...formData, organization: e.target.value })}
                  placeholder="Organization Name"
                  className="w-full px-6 py-4 border border-gray-300 rounded-xl text-[#1a2b4a] text-sm focus:outline-none focus:border-[#2d9b9b] focus:ring-2 focus:ring-[#2d9b9b]/20 transition-all duration-300"
                />
              </div>

              <div>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Tell me about your organization and what you're hoping to accomplish"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-6 py-4 border border-gray-300 rounded-xl text-[#1a2b4a] text-sm focus:outline-none focus:border-[#2d9b9b] focus:ring-2 focus:ring-[#2d9b9b]/20 transition-all duration-300 resize-none"
                ></textarea>
                <p className="text-xs text-gray-500 mt-2">Maximum 500 characters</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#1a2b4a] text-white px-8 py-4 rounded-full hover:bg-[#0f1a2e] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
                <i className="ri-arrow-right-line"></i>
              </button>

              {submitStatus === 'success' && (
                <div className="p-4 bg-[#2d9b9b]/10 border border-[#2d9b9b] rounded-xl text-[#2d9b9b] text-sm">
                  Thank you for reaching out! I'll get back to you soon.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-300 rounded-xl text-red-600 text-sm">
                  Something went wrong. Please try again or contact me directly.
                </div>
              )}
            </form>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600 mb-3">Prefer to reach out directly?</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="mailto:jerilyn@jerilynemerson.com" className="inline-flex items-center gap-2 text-[#2d9b9b] hover:text-[#258080] transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i>
                  jerilyn@jerilynemerson.com
                </a>
                <a href="tel:+15128264898" className="inline-flex items-center gap-2 text-[#2d9b9b] hover:text-[#258080] transition-colors cursor-pointer">
                  <i className="ri-phone-line"></i>
                  (512) 826-4898
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}